import React from "react";
import { ExternalLink, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Block "Rejoindre le CEF officiel" displayed at the bottom of the home page
 * and in the user profile. The destination URL is read from
 * site_config.fab.join_cef_url (editable in admin) with a sensible default.
 */
export default function JoinCefBlock({ variant = "yellow", className = "" }) {
  const [url, setUrl] = React.useState("https://lecef.org/");
  React.useEffect(() => {
    api.get("/site-config").then((r) => {
      const u = r.data?.fab?.join_cef_url;
      if (u) setUrl(u);
    }).catch(() => {});
  }, []);

  const bg = variant === "black" ? "bg-black text-white" : "bg-cef-yellow text-black";

  return (
    <section className={`neo-card p-5 sm:p-6 ${bg} ${className}`} data-testid="join-cef-block">
      <div className={`chip mb-3 ${variant === "black" ? "bg-cef-yellow text-black" : "bg-black text-white"}`}>
        <Sparkles className="w-3.5 h-3.5 mr-1" /> Adhère au CEF officiel
      </div>
      <h3 className="font-display font-black text-xl sm:text-2xl tracking-tighter uppercase leading-tight">
        Devenir membre officiel du CEF
      </h3>
      <p className="mt-2 text-sm">
        Au-delà de ton compte sur Élève ta voix, tu peux <strong>rejoindre officiellement</strong> le Comité des Élèves Francophones et participer à ses AG, élections et actions de terrain.
      </p>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`mt-3 inline-flex items-center neo-btn text-sm py-2 ${variant === "black" ? "bg-cef-pink text-white" : "bg-black text-white"}`}
        data-testid="join-cef-link"
      >
        Adhérer au CEF <ExternalLink className="w-4 h-4 ml-1" />
      </a>
    </section>
  );
}
